module.exports = __webpack_public_path__ + "static/media/alert_partner_gold_x1_new.95ad4584.png";